import { arraySchema, castUnsafe, type ApiSchema } from "vue-utils"
import { IdPath } from "./IdPath"
import { MemberPath } from "./MemberPath"

export * from "./BasePath"

export * from "./IdPath"
export * from "./MemberPath"

export type ObjectPathEntry = MemberPath | IdPath
export type ObjectPath = ObjectPathEntry[]

export const ObjectPathEntrySchema: ApiSchema<ObjectPathEntry> = (path) => {
	if (path.startsWith("{")) return IdPath.fromJSON(path)
	if (path.startsWith(".")) return MemberPath.fromJSON(path)

	throw new Error(`Invalid path '${path}'`)
}

export const ObjectPathSchema: ApiSchema<ObjectPath> = arraySchema(ObjectPathEntrySchema)

export function resolvePath(path: ObjectPath, value: unknown) {
	let currentValue = value
	for (const entry of path) {
		currentValue = entry.getValue(currentValue)
	}
	return currentValue
}

export function getNestedSchema<T>(schema: ApiSchema<T>, path: ObjectPath): ApiSchema<unknown> {
	let currentSchema: ApiSchema<unknown> = castUnsafe(schema)
	for (const entry of path) {
		currentSchema = entry.resolveSchema(currentSchema)
	}
	return currentSchema
}
